module.exports = __webpack_public_path__ + "img/kiwi.c613a70b.jpeg";